import { Button } from "@marketplace/ui";
import { type DataTableColumn } from "@marketplace/ui/data-table";
import { useSetAtom } from "jotai";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineTextSnippet } from "react-icons/md";

import { automationDetailModalAtom } from "../atoms/automation-detail-modal-atom";
import { AutomationListTableActions } from "../components/automation-list-table-actions/automation-list-table-actions";
import type { AutomationListItem } from "../types";

export const useAutomationListTableColumns = (page: number) => {
  const { t } = useTranslation("product", { keyPrefix: "automation" });
  const setDetailModal = useSetAtom(automationDetailModalAtom);

  const columns = useMemo<DataTableColumn<AutomationListItem>[]>(
    () => [
      {
        accessor: "no",
        title: t("listPage.table.columns.no"),
        render: (_, index) => (page - 1) * 10 + index + 1
      },
      {
        accessor: "product_id",
        title: t("listPage.table.columns.productId"),
        render: ({ product_id }) => product_id ?? "-"
      },
      {
        accessor: "product_name",
        title: t("listPage.table.columns.productName"),
        render: ({ product_name }) => product_name ?? "-"
      },
      {
        accessor: "host",
        title: t("listPage.table.columns.host"),
        render: ({ host }) => host ?? "-"
      },
      {
        accessor: "host_auth",
        title: t("listPage.table.columns.hostAuth"),
        render: ({ host_auth }) => (host_auth == "" ? "-" : host_auth)
      },
      {
        accessor: "detail",
        title: "Action",
        render: (record) => (
          <Button
            variant="secondary"
            size="sm"
            rightSection={<MdOutlineTextSnippet size={14} />}
            onClick={() =>
              setDetailModal({ visible: true, automationId: record.id })
            }
          >
            {t("listPage.table.actions.detail")}
          </Button>
        )
      },
      {
        accessor: "actions",
        title: "",
        render: (record) => (
          <div className="flex justify-end">
            <AutomationListTableActions automation={record} />
          </div>
        )
      }
    ],
    [t, page, setDetailModal]
  );

  return columns;
};
